import { useState, useEffect } from "react";
import { addgmailApi } from "../services/authApi"
import { Box, Link, Button, Typography } from '@mui/material';


const AddGmail = () => {

  const [message, setMessage] = useState("");

  const setEmail = async () => {
    try {
      const searchParams = new URLSearchParams(window.location.search)
      if (searchParams.size == 0) {
        setMessage("خطا در ثبت جیمیل")
      }
      else if (searchParams.size > 1) {
        setMessage("خطا در ثبت جیمیل")
      }
      else {
        for (const param of searchParams) {
          if (param[0] == "code") {
            await addgmailApi({ code: param[1] })
          } else setMessage("خطا در ثبت جیمیل")
        }
      }
      setTimeout(() => {
        window.location.href = "/"
      }, 5000);
    } catch (error) {
      setMessage("خطا در ثبت جیمیل")
    }
  }

  useEffect(() => {
    setEmail()
  }, []);
  setTimeout(() => {
    window.location.href = "/"
  }, 5000);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: "#3F4652",
      }}
    >
      <Typography>
        {message}
      </Typography>
      {message ? (
        <Link to="/" style={{ textDecoration: "none" }}>
          <Button variant="contained">
            {`درحال برگشت  اتوماتیک به صفحه اصلی ... (برای برگشت سریع کلیک کنید)`}
          </Button>
        </Link>
      ) : ""}

    </Box>
  );
};

export default AddGmail;
